import React, { useState, useEffect } from "react";
import style from "../../style/HistoryListBody.module.scss";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import PenToSquareRegular from "../Icon/PenToSquareRegular";
import UnlockKeyholeRegular from "../Icon/UnlockKeyholeRegular";
import LockRegular from "../Icon/LockRegular";
import LockSolid from "../Icon/LockSolid";
import BellSlashRegular from "../Icon/BellSlashRegular";
import dayjs from "dayjs";
import Logger from "../../libraries/Logger";

function AccountManageListBody({ data }) {
  const [isOtherHospital, setIsOtherHospital] = useState(null);
  useEffect(() => {
    setIsOtherHospital(
      JSON.parse(localStorage.getItem("auth"))?.IsOtherHospital
    );
  }, [isOtherHospital]);

  return (
    <Table className={style.table}>
      <Thead>
        <Tr className={style.table_title}>
          <Th className={style.table_title_self}>建檔時間</Th>
          <Th className={style.table_title_self}>管理者姓名</Th>
          <Th className={style.table_title_self}>帳號信箱</Th>
          <Th className={style.table_title_self}>所屬醫院</Th>
          <Th className={style.table_title_self}>職務類型</Th>
          <Th className={style.table_title_self}>員工編號</Th>
          <Th className={style.table_title_self}>帳號狀態</Th>
          <Th className={style.table_title_self}>編輯</Th>
          <Th className={style.table_title_self}>最新操作者</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data?.AccountData?.map((v, i) => {
          return (
            <Tr key={i} className={style.table_body}>
              <Td className={style.table_body_self}>
                {dayjs(v.CreateDateTime).format("YYYY/MM/DD HH:mm")}
              </Td>
              <Td className={style.table_body_self}>{v.Name}</Td>
              <Td className={style.table_body_self}>{v.Account}</Td>
              <Td className={style.table_body_self}>{v.OrgName}</Td>
              <Td className={style.table_body_self}>
                {v.Identities?.join("|")}
              </Td>
              <Td className={style.table_body_self}>{v.StaffCode}</Td>
              <Td className={style.table_body_self}>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      margin: "5px",
                    }}
                  ></span>
                  {v.LoginMethodStatus === 5 ? "停用-臨時帳號" : ""}
                  {v.LoginMethodStatus === 4 ? "啟用-臨時帳號" : ""}
                  {v.LoginMethodStatus === 3 ? "啟用-未驗證" : ""}
                  {v.LoginMethodStatus === 1 ? "啟用-已驗證" : ""}
                  {v.LoginMethodStatus === 2 ? "已停用" : ""}
                  {v.LoginMethodStatus === 1 || v.LoginMethodStatus === 3 ? (
                    <p
                      style={{
                        padding: "1px 1px 1px 5px",
                        alignItems: "center",
                      }}
                    >
                      <LockRegular RowId={v.RowId} Status={2} />
                    </p>
                  ) : (
                    ""
                  )}
                  {v.LoginMethodStatus === 2 ? (
                    <p
                      style={{
                        padding: "1px 1px 1px 5px",
                        alignItems: "center",
                      }}
                    >
                      <UnlockKeyholeRegular RowId={v.RowId} Status={1} />
                    </p>
                  ) : (
                    ""
                  )}
                </p>
              </Td>
              <Td className={style.table_body_self}>
                {
                  <PenToSquareRegular
                    navigatePath={`/AccountEdit?rowId=${v.RowId}`}
                  />
                }
              </Td>
              <Td className={style.table_body_self}>
                {v.ModifyUser}
                <span style={{paddingLeft:'8px'}}>{dayjs(v.ModifyDateTime).format("MM/DD HH:mm")}</span>
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}

export default AccountManageListBody;
